import React from 'react';
import { parseInline } from '../utils/markdownParser';
import { openExternalUrl, isYouTubeUrl } from '../utils/urlHelper';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiExternalLink, FiYoutube } = FiIcons;

const InlineContent = ({ text, dark = false }) => {
  const tokens = parseInline(text);

  return (
    <>
      {tokens.map((token, i) => {
        if (token.type === 'bold') {
          return (
            <strong key={i} style={{ color: dark ? '#e8d5b5' : '#3d2c0f' }} className="font-semibold">
              {token.text}
            </strong>
          );
        }
        if (token.type === 'link') {
          const isYT = isYouTubeUrl(token.href);
          return (
            <button
              key={i}
              type="button"
              onClick={() => openExternalUrl(token.href)}
              className="inline-flex items-center gap-1.5 px-2.5 py-0.5 mx-0.5 rounded-md text-[12.5px] font-medium border transition-all duration-200 hover:shadow-sm cursor-pointer"
              style={isYT ? {
                backgroundColor: dark ? 'rgba(255,0,0,0.18)' : '#fff5f5',
                borderColor: dark ? 'rgba(255,80,80,0.35)' : '#fecaca',
                color: dark ? '#fca5a5' : '#dc2626',
              } : {
                backgroundColor: dark ? 'rgba(255,255,255,0.12)' : '#fdf8f3',
                borderColor: dark ? 'rgba(255,255,255,0.22)' : '#e8d9c4',
                color: dark ? '#f5e6d0' : '#543e18',
              }}
            >
              {isYT && <SafeIcon icon={FiYoutube} className="w-3.5 h-3.5 flex-shrink-0" />}
              {token.label}
              <SafeIcon icon={FiExternalLink} className="w-3 h-3 flex-shrink-0" />
            </button>
          );
        }
        return <span key={i}>{token.text}</span>;
      })}
    </>
  );
};

export default InlineContent;